import React, { FC } from "react";
import classNames from "classnames";
import { NoNameChatItemIcon } from "@/icons/primary/no-name-chat-item-icon";
import { BemHelper } from "../../utils";
import digitalYouRobotIcon from "../../images/digital-you-robot.svg";
import defaultImage from "../../images/default-avatar.jpg";

const bem = new BemHelper("chat-avatar");

export type Props = { pictureUrl?: string; width?: number; noName?: boolean; shortName?: string };

const colorPicker = (letter: string) => {
  if (letter.match(/[a-f]/i)) return "bg-light-success";
  if (letter.match(/[f-i]/i)) return "bg-light-danger";
  if (letter.match(/[i-l]/i)) return "bg-light-info";
  if (letter.match(/[l-r]/i)) return "bg-light-purple";
  if (letter.match(/[r-z]/i)) return "bg-light-warning";
  return "bg-light-neutral-3";
};

export const AvatarChat: FC<Props> = ({ pictureUrl, width = 80, noName, shortName }) => {
  return (
    <div
      className={classNames([
        bem.block(),
        noName && "bg-dark-neutral-2",
        shortName && colorPicker(shortName[0].toLowerCase()),
      ])}
      style={{
        ...(!noName && !shortName
          ? { background: `url('${pictureUrl || defaultImage}') no-repeat` }
          : {}),
        width,
        minWidth: width + "px",
        height: width + "px",
      }}
    >
      {shortName && <span className={classNames("text-xs font-semibold")}>{shortName}</span>}
      {!shortName && noName && <NoNameChatItemIcon style={{ fontSize: width * 0.6 }} />}
      {!shortName && !noName && (
        <div
          className={classNames([bem.modifier("robot")])}
          style={{ border: `${+width * 0.025}px solid white` }}
        >
          <img src={digitalYouRobotIcon} alt='' />
        </div>
      )}
    </div>
  );
};
